import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=5323261d&scoped=true&"
import script from "./ErrorHandler.vue?vue&type=script&lang=js&"
export * from "./ErrorHandler.vue?vue&type=script&lang=js&"
import style0 from "./ErrorHandler.vue?vue&type=style&index=0&id=5323261d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323261d",
  null
  
)

export default component.exports